import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import EditIcon from '@mui/icons-material/Edit';
import request from "../../../Helpers/API";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { EstadoResultadosChart } from "./EstadoResultadosChart";
import { AgruparEstadoResultados } from "../Helper/AgruparEstadoResultados";
import { ArrayTotalizarByProp } from "../Actions/TotalizarProps";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { EstadoResultadosButton } from "./EstadoResultadosButton";

export const EstadoResultadosGrafica = ({ data, ejercicio, ejerciciofin }) => {
    const history = useHistory();
    const { state } = useLocation();
    const [info, setInfo] = useState({
        data: [],
        result: data,
        totales: {
            total: 0,
            proyectado: 0,
            totallast: 0,
            // proyectadolast: 0
        },
    });
    // console.log(data)
    const [graficar, setGraficar] = useState({ grupo: "adr", tipo: "3" });

    useEffect(() => {
        setInfo({ ...info, result: data })
    }, [data]);

    const concepto = (tipo) => {
        switch (tipo) {
            // case "1":
            //     return "Ventas Brutas";
            // case "2":
            //     return "Descuentos";
            case "3":
                return "Ventas Netas";
            case "4":
                return "Costos de Venta";
            case "5":
                return "Utilidad Bruta";
            case "6":
                return "Gastos Departamentales";
            case "7":
                return "Utilidad Operaicón";
        }
    };

    useEffect(() => {
        var result = AgruparEstadoResultados(
            info.result,
            graficar.grupo,
            graficar.tipo
        );
        var newArray = [
            [
                "",
                `${concepto(graficar.tipo)}`,
                `Proyección ${concepto(graficar.tipo)}`,
                `${concepto(graficar.tipo)} ANTERIOR`,
            ],
        ];
        if (graficar.grupo === "adr") {
            newArray = [
                ...newArray,
                [
                    "Grupo",
                    ArrayTotalizarByProp(result, "total"),
                    ArrayTotalizarByProp(result, "proyectado"),
                    ArrayTotalizarByProp(result, "totallast"),
                ],
            ];
        }

        result.forEach((item) => {
            newArray = [
                ...newArray,
                [item.display, item.total, item.proyectado, item.totallast],
            ];
        });

        setInfo({
            ...info,
            data: result,
            totales: {
                total: ArrayTotalizarByProp(result, "total"),
                proyectado: ArrayTotalizarByProp(result, "proyectado"),
                totallast: ArrayTotalizarByProp(result, "totallast"),
                // proyectadolast: ArrayTotalizarByProp(result, "proyectadolast")
            },
        });
        // setSubTitulo(`${concepto(graficar.tipo)} por ${graficar.grupo} `);
        // addGrafica(newArray);
    }, [info.result, graficar]);


    // console.log(info)
    return (

        <div className="estado-resultado-grafica">
            <div className="button-section-graficar">
                <EstadoResultadosButton info={graficar} onChange={setGraficar} />
            </div>
            
            <div className="estado-resultado-grafica-chart">
                <EstadoResultadosChart name={'chart-estado-resultados'} data={info} filtrado={graficar.grupo}/>
            </div>
            <div className="estado-resultado-grafica-container scroll-4">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th colSpan={4}>
                                {ejercicio}
                            </th>
                            <th colSpan={3}>
                                <div>{ejerciciofin}</div>
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th>Real</th>
                            <th>Proyección</th>
                            <th>Desviación</th>
                            <th>%</th>
                            <th>Real</th>
                            <th>Desviación</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {info.data != undefined &&
                            info.data != null &&
                            info.data.length > 0 ? (
                            info.data.map((item) => (
                                <tr>
                                    <td>
                                        {item.display}
                                    </td>
                                    <td className="ta-right bl">
                                        {FormatMoney(item.total, 0)}
                                    </td>
                                    <td className="ta-right">
                                        {FormatMoney(item.proyectado, 0)}
                                    </td>
                                    <td className="ta-right">
                                        {FormatMoney(item.total - item.proyectado, 0)}
                                    </td>
                                    <td style={{ paddingRight: 10 }} className="ta-right">
                                        {item.total === 0 || item.proyectado === 0
                                            ? 0
                                            : FormatMoney(
                                                ((item.total - item.proyectado) / item.proyectado) *
                                                100
                                            )}{" "}
                                        %
                                    </td>
                                    <td className="ta-right bl">
                                        {FormatMoney(item.totallast)}
                                    </td>
                                    <td className="ta-right">
                                        {FormatMoney(item.total - item.totallast)}
                                    </td>
                                    <td style={{ paddingRight: 10 }} className="ta-right br">
                                        {item.total === 0 || item.totallast === 0
                                            ? 0
                                            : FormatMoney(
                                                ((item.total - item.totallast) / item.totallast) *
                                                100
                                            )}{" "}
                                        %
                                    </td>
                                    {/* <td className="ta-right">
                                                {FormatMoney(item.proyectadolast)}
                                            </td> */}
                                </tr>
                            ))
                        ) : (
                            <div>Sin datos para mostrar</div>
                        )}
                        <tr style={{ fontWeight: "bold" }}>
                            <td
                                style={{
                                    fontWeight: "bold",
                                    textAlign: "right",
                                    paddingRight: 10,
                                }}
                                className="bl"
                            >
                                TOTAL
                            </td>
                            <td className="ta-right bl">
                                {FormatMoney(info.totales.total)}
                            </td>
                            <td className="ta-right">
                                {FormatMoney(info.totales.proyectado)}
                            </td>
                            <td className="ta-right">
                                {FormatMoney(info.totales.total - info.totales.proyectado)}
                            </td>
                            <td className="ta-right " style={{ paddingRight: 10 }}>
                                {FormatMoney(
                                    ((info.totales.total - info.totales.proyectado) /
                                        info.totales.proyectado) *
                                    100
                                )}{" "}
                                %
                            </td>
                            <td className="ta-right bl">
                                {FormatMoney(info.totales.totallast)}
                            </td>
                            <td className="ta-right ">
                                {FormatMoney(info.totales.total - info.totales.totallast)}
                            </td>
                            <td className="ta-right br" style={{ paddingRight: 10 }}>
                                {FormatMoney(
                                    ((info.totales.total - info.totales.totallast) /
                                        info.totales.totallast) *
                                    100
                                )}{" "}
                                %
                            </td>
                        </tr>
                    </tbody>
                </table >
            </div >
        </div >
    );
};
